<div class="card border-0 shadow-sm mb-4">
    <div class="card-body" [class.placeholder-glow]="isLoading()">
        <div class="d-flex justify-content-between align-items-baseline mb-3 flex-wrap gap-2">
            <h5 class="fw-semibold mb-0">{{ title() }}</h5>
            @if (!isLoading() && section()) {
                <div class="text-end">
                    <span class="text-muted small me-2">Planned</span>
                    <span class="fw-bold fs-5">{{ section()!.totalBudgeted | CurrencyDisplay: currency()! }}</span>
                </div>
            }
        </div>

        @if (isLoading()) {
            <div class="placeholder col-12 mb-2"></div>
            <div class="placeholder col-12 mb-2"></div>
            <div class="placeholder col-12 mb-2"></div>
        } @else if (!section()?.accounts || section()!.accounts!.length === 0) {
            <p class="text-muted mb-0">No activity for this section.</p>
        } @else {
            <!-- Desktop / tablet: full table -->
            <div class="table-responsive budget-section-table d-none d-md-block">
                <table class="table table-hover align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col">Account</th>
                            <th scope="col" class="text-end">Budgeted</th>
                            <th scope="col" class="text-end">Actual</th>
                            <th scope="col" class="text-end">Variance</th>
                            <th scope="col" class="text-end">% Variance</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of section()!.accounts; track row.account.chartOfAccountId) {
                            <tr>
                                <td>
                                    <div class="fw-semibold">
                                        {{ row.account.accountNumber }} - {{ row.account.name }}
                                        @if (!row.account.isActive) {
                                            <span class="badge bg-warning-subtle text-warning-emphasis ms-1">Retired</span>
                                        }
                                    </div>
                                    @if (row.account.description) {
                                        <div class="text-muted small">{{ row.account.description }}</div>
                                    }
                                </td>
                                <td class="text-end">{{ row.budgetedAmount | CurrencyDisplay: currency()! }}</td>
                                <td class="text-end fw-semibold">{{ row.actualAmount | CurrencyDisplay: currency()! }}</td>
                                <td class="text-end" [class]="varianceClass(row.variance)">
                                    {{ row.variance | CurrencyDisplay: currency()! }}
                                </td>
                                <td class="text-end" [class]="varianceClass(row.variance)">
                                    {{ variancePercentage(row.variance, row.budgetedAmount) }}
                                </td>
                            </tr>
                        }
                    </tbody>
                    <tfoot>
                        <tr class="border-top fw-bold">
                            <td>Total</td>
                            <td class="text-end">{{ section()!.totalBudgeted | CurrencyDisplay: currency()! }}</td>
                            <td class="text-end">{{ section()!.totalActual | CurrencyDisplay: currency()! }}</td>
                            <td class="text-end" [class]="varianceClass(section()!.totalVariance)">
                                {{ section()!.totalVariance | CurrencyDisplay: currency()! }}
                            </td>
                            <td class="text-end" [class]="varianceClass(section()!.totalVariance)">
                                {{ variancePercentage(section()!.totalVariance, section()!.totalBudgeted) }}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <!-- Mobile: dense 2-line rows -->
            <div class="d-md-none">
                @for (row of section()!.accounts; track row.account.chartOfAccountId) {
                    <div class="py-3 border-bottom">
                        <div class="d-flex justify-content-between align-items-baseline gap-2">
                            <div class="fw-semibold text-truncate">
                                {{ row.account.accountNumber }} - {{ row.account.name }}
                                @if (!row.account.isActive) {
                                    <span class="badge bg-warning-subtle text-warning-emphasis ms-1">Retired</span>
                                }
                            </div>
                            <div class="fw-bold text-nowrap">{{ row.actualAmount | CurrencyDisplay: currency()! }}</div>
                        </div>
                        @if (row.account.description) {
                            <div class="text-muted small">{{ row.account.description }}</div>
                        }
                        <div class="d-flex justify-content-between align-items-baseline small gap-2 mt-1">
                            <span class="text-muted">of {{ row.budgetedAmount | CurrencyDisplay: currency()! }} budgeted</span>
                            <span class="text-nowrap" [class]="varianceClass(row.variance)">
                                {{ row.variance | CurrencyDisplay: currency()! }}
                                <span class="ms-1">{{ variancePercentage(row.variance, row.budgetedAmount) }}</span>
                            </span>
                        </div>
                    </div>
                }
                <!-- Total -->
                <div class="pt-3 fw-bold">
                    <div class="d-flex justify-content-between align-items-baseline gap-2">
                        <div>Total</div>
                        <div class="text-nowrap">{{ section()!.totalActual | CurrencyDisplay: currency()! }}</div>
                    </div>
                    <div class="d-flex justify-content-between align-items-baseline small gap-2 mt-1 fw-normal">
                        <span class="text-muted">of {{ section()!.totalBudgeted | CurrencyDisplay: currency()! }} budgeted</span>
                        <span class="text-nowrap fw-semibold" [class]="varianceClass(section()!.totalVariance)">
                            {{ section()!.totalVariance | CurrencyDisplay: currency()! }}
                            <span class="ms-1">{{ variancePercentage(section()!.totalVariance, section()!.totalBudgeted) }}</span>
                        </span>
                    </div>
                </div>
            </div>
        }
    </div>
</div>
